import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";
import Modal from "../components/Modal";

export default function Project() {
  const { data } = useContext(AppContext);
  const [state, setstate] = useState(0);
  const [val, setval] = useState(null);
  const [open, setOpen] = useState(false);
  const map = [
    {
      name:'沈阳K11店',
      x:123.444294,
      y:41.756735,
      cover:"./image/shop-photo1.jpg" ,
      detail:"辽宁省沈阳市和平区博览路2甲1号，k11购物艺术中心L5层5011号",
      time:"AM:10:00 - PM:21:00（最晚预约时间19:30）",
      tel:"13840181881"
    },
    {
      name:'延吉百利城店',
      x:129.519699,
      y:42.913123,
      cover:"./image/shop-photo2.jpg" ,
      detail:"吉林省延吉市百利城购物中心四层416号",
      time:"AM:10:00 - PM:21:00（最晚预约时间19:30）",
      tel:"18626989763"
    },
    {
      name:'大连大都汇店',
      x:121.644554,
      y:38.922484,
      cover:"./image/shop-photo3.jpg" ,
      detail:"辽宁省大连市中山区葵英街道，玉光街102号",
      time:"AM:10:00 - PM:21:00（最晚预约时间19:30）",
      tel:"18524113905"
    },
  ]
   function scrollTop (){
    document.getElementById("app").scrollTo({
      top: 0,
      behavior: "smooth" // 平滑滚动
    }); 
  }
  useEffect(() => {
    if (open) {
      // 这里的代码会在 open 变为 true 且组件更新后执行
      console.log("弹窗已打开，DOM 已更新");

      
      var map = new window.BMapGL.Map("map99"); 
      var point = new window.BMapGL.Point(val.x,val.y); // 默认中心：北京天安门
      map.centerAndZoom(point, 16);
      map.enableScrollWheelZoom(true);
      var marker = new window.BMapGL.Marker(point);
      map.addOverlay(marker);
      var navCtrl = new window.BMapGL.NavigationControl3D(); // 3D导航控件
      map.addControl(navCtrl);
      var zoomCtrl = new window.BMapGL.ZoomControl();  
      map.addControl(zoomCtrl);
      // 例如可以在这里操作 DOM 或调用第三方库
    }
  }, [open]);

  const handleOpen = (val,index) => {
    setstate(index)
    
    setval(val);
    setOpen(true);
  };
  useEffect(() => {

    map.map((val,index)=>{
      var map = new window.BMapGL.Map("map"+index); 
      var point = new window.BMapGL.Point(val.x,val.y); // 默认中心：北京天安门
      map.centerAndZoom(point, 16);
      map.enableScrollWheelZoom(true);
      var marker = new window.BMapGL.Marker(point);
      map.addOverlay(marker);
      var navCtrl = new window.BMapGL.NavigationControl3D(); // 3D导航控件
      map.addControl(navCtrl);
      var zoomCtrl = new window.BMapGL.ZoomControl();  
      map.addControl(zoomCtrl);
    })
    
  }, []); // 空数组 => 只在首次挂载时执行（等价于 componentDidMount）

  return (
    <div id="pShop">
      <img src={`/image/6.png`} className="pageTitle" />
      <div  class="pContent" >
        {
          map.map((val,index)=>
            <div  class="block" key={index}>
              <div  class="blockTit">{val.name}</div>
              <div  class="shop-photo clearfix">
                <div  class="item">
                  <img  src={val.cover} alt="" />
                </div>
                <div  class="item bmap"> 
                  <img onClick={()=>handleOpen(val,index)} src="data:image/png;base64,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" alt="" />
                  <div id={"map"+index}></div>
                </div>
              </div>
              <div  class="blockText">{val.detail}</div>
              <div  class="blockText">{val.time}</div>
              <div  class="blockText"> 预约电话：<a  href={"tel:"+val.tel}>{val.tel}</a></div>
            </div>
          )
        }
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
          <h2 >{map[state].name}</h2>
          <p >{map[state].detail}</p>
          <div id={"map99"}></div>
      </Modal>
      
      <section  onClick={()=>scrollTop()} id="toTop"><span >PAGE TOP</span></section>
    </div>
  );
}